(function () {
  var product = window.__variationProduct;
  if (!product) return;

  var form = document.querySelector('form[action*="/cart/add"]');
  var variantSelect = form ? form.querySelector('select[name="id"]') : null;
  if (!variantSelect) {
    variantSelect = document.querySelector('select#ProductSelect-product-template');
  }

  var variants = product.variants || [];
  var curSize = null;
  var curColor = null;

  var sizeSelect = document.querySelector('select[name="Size"], select[name="option1"]');
  if (sizeSelect) curSize = sizeSelect.value;

  function findVariant(size, color) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var sizeMatch = size === null ? true : v.options[0] === size;
      var colorMatch = color === null ? true : v.options[1] === color;
      if (sizeMatch && colorMatch) return v;
    }
    return null;
  }

  document.querySelectorAll('.variation-swatch[data-option-index="1"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.classList.contains('unavailable')) return;
      curColor = this.getAttribute('data-value');

      var v = findVariant(curSize, curColor);
      if (v && variantSelect) {
        variantSelect.value = v.id;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      document.querySelectorAll('.variation-swatch[data-option-index="1"]').forEach(function (s) {
        s.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  if (sizeSelect) {
    sizeSelect.addEventListener('change', function () {
      curSize = this.value;
      var v = findVariant(curSize, curColor);
      if (v && variantSelect) {
        variantSelect.value = v.id;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
})();